import React from "react"
import { Box, Typography } from "@mui/material"
import CircleIcon from "@mui/icons-material/Circle"
import BookTwoToneIcon from "@mui/icons-material/BookTwoTone"
import EuroSymbolTwoToneIcon from "@mui/icons-material/EuroSymbolTwoTone"
// import PaymentsTwoToneIcon from "@mui/icons-material/PaymentsTwoTone"

const PotentialPartners = ({ countPotentialPartners, action, isMobile }) => {
  const PartnerIcon = action === "buy" ? BookTwoToneIcon : EuroSymbolTwoToneIcon

  return countPotentialPartners ? (
    <Box sx={{ p: 0.5, border: "1px solid #98e39c", borderRadius: 2, mt: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
        <PartnerIcon fontSize={isMobile ? "small" : "medium"} sx={{ color: "#98e39c", mr: 0.5, pl: 0, display: "inline", verticalAlign: "middle" }} />
        Es gibt einen {action === "buy" ? "Verkäufer" : "Käufer"}
      </Typography>

      <Typography variant="body2" sx={{ pl: 0.5 }}>
        Du kannst mit dem {action === "buy" ? "Verkäufer" : "Käufer"} direkt Kontakt aufnehmen, indem du auf{" "}
        <b>"Buch {action === "buy" ? "kaufen" : "verkaufen"}"</b> klickst. <br />
        Ihr könnt euch im Chat zum Preis austauschen und ein Treffen für die Übergabe des Buches vereinbaren. <br />
        Wenn etwas nicht passen sollte, kannst du unten auf "Abbrechen" klicken und einen neuen Partner suchen.
      </Typography>
    </Box>
  ) : (
    <Box sx={{ p: 0.5, border: "1px solid #ccc", borderRadius: 2, mt: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
        <CircleIcon fontSize={isMobile ? "small" : "medium"} sx={{ color: "#ccc", mr: 0.5, pl: 0, display: "inline", verticalAlign: "middle" }} />
        Es gibt noch keinen {action === "buy" ? "Verkäufer" : "Käufer"}
      </Typography>

      <Typography variant="body2" sx={{ pl: 0.5 }}>
        Klicke auf "Buch {action === "buy" ? "kaufen" : "verkaufen"}", um einen {action === "buy" ? "Verkäufer" : "Käufer"} zu suchen
      </Typography>
    </Box>
  )
}

export default PotentialPartners
